module.exports = __webpack_public_path__ + "static/media/292128.e73484f8.png";